// Кому на этой вкладке открывать локальную БД PowerSync.
//
// Открытие — не бесплатная операция: worker-чанк, WASM SQLite, IndexedDB и
// сторож worker-режима (`db-impl.web.ts`) на 8 секунд. Раньше провайдер
// открывал БД безусловно, до ответа о сессии, — то есть каждому гостю и
// каждому краулеру на лендинге и в каталоге. Данных у гостя в базе нет и быть
// не может (синк ему не поднимается), а сторож на медленной среде краулера
// срабатывал и заводил в Hawk «worker-режим не открыл БД (timeout)»
// (OXEM-588: 4 из 6 повторов — краулер на страницах витрины).
//
// Правило:
//   • сессия подтверждена — открываем: синк без базы не поднять;
//   • на устройстве уже есть владелец базы — открываем сразу, не дожидаясь
//     ответа о сессии: человек с протухшей сессией или без сети читает свой
//     кэш офлайн, и это заявленное поведение (`powersync-provider.tsx`);
//   • иначе (гость, бот, первый визит) — не открываем.
//
// Закрывать однажды открытую базу правило не умеет и не должно: потребители
// SDK-хуков не переживают переход «база была → базы нет» (см. границу в
// провайдере), а выход из аккаунта и так чистит базу, не закрывая её.

export interface LocalDbGateInput {
	/** Сессия подтверждена сервером (`useAuth().isAuthenticated` при `!isLoading`). */
	readonly authenticatedUserId: string | null;
	/** Отметка владельца локальной базы (`readPowerSyncOwner()`). */
	readonly owner: string | null;
}

export function shouldOpenLocalDb({ authenticatedUserId, owner }: LocalDbGateInput): boolean {
	return authenticatedUserId !== null || owner !== null;
}
